<template>
    <v-main style="height: 100vh;">
        <img :class="{'topleft':true,'smalll':$vuetify.breakpoint.xsOnly}" :src="require('@/assets/HTC_Asset_28.png')"  />
        <img :class="{'topright':true,'smallr':$vuetify.breakpoint.xsOnly}" :src="require('@/assets/HTC_Asset_28.png')"  />
        <img class="bottomleft" :src="require('@/assets/HTC_Asset_28.png')"  />
        <img class="bottomright" :src="require('@/assets/HTC_Asset_28.png')"  />
        <v-container>
            <v-row align="center">
                <v-col align="center"  >
                    <div style="width:100%;height:40px;"></div>
                    <v-card v-for="(a,i) in faqs" :key="i"  class="mb-2" outlined max-width="500">
                        <v-card-text>
                            <div class="font-weight-light subtitle-1 text-left">
                                {{a.q}}
                            </div>
                            <div class="font-weight-black subtitle-1 text-left">
                                {{a.a}}
                            </div>
                        </v-card-text>
                    </v-card>
                    <div style="width:100%;height:40px;"></div>
                </v-col>
            </v-row>
        </v-container>
    </v-main>
</template>

<script>
  import {
    mapActions
  } from 'vuex'
  export default {
    components: {},
    name: "Faqs",
    data() {
      return {
        faqs:[]
      }
    },
    mounted() {
      this.getFaqs()
    },
    methods: {
      ...mapActions(['openGet']),
      async getFaqs(){
        let f = await this.openGet({path:'api/auth/faq'})
        this.faqs = f
      }
    }
  }
</script>

<style scoped>
    a{
        text-decoration: none;
    }
    .brd{
        border-radius:3px;
        border:solid thin #555555;
    }
</style>